/**
 * One-click style presets. Each one is a partial `design` patch, so picking a
 * preset only touches shape and colour — content, logo, frame and export
 * settings the user already chose are left alone.
 */
export const STYLE_PRESETS = [
    {
        id: 'classic',
        dotStyle: 'square',
        eyeFrameStyle: 'square',
        eyeBallStyle: 'square',
        fgColor: '#1C1815',
        bgColor: '#FFFFFF',
        gradientEnabled: false,
    },
    {
        id: 'warm',
        dotStyle: 'rounded',
        eyeFrameStyle: 'rounded',
        eyeBallStyle: 'rounded',
        fgColor: '#E68A00',
        bgColor: '#FFF8E6',
        gradientEnabled: false,
    },
    {
        id: 'dots',
        dotStyle: 'dot',
        eyeFrameStyle: 'circle',
        eyeBallStyle: 'circle',
        fgColor: '#2D74D6',
        bgColor: '#FFFFFF',
        gradientEnabled: false,
    },
    {
        id: 'gradient',
        dotStyle: 'extra-rounded',
        eyeFrameStyle: 'extra-rounded',
        eyeBallStyle: 'extra-rounded',
        fgColor: '#6D5BD0',
        bgColor: '#FFFFFF',
        gradientEnabled: true,
        gradientType: 'linear',
        gradientFrom: '#6D5BD0',
        gradientTo: '#E0492B',
        gradientRotation: 45,
    },
    {
        id: 'leaf',
        dotStyle: 'leaf',
        eyeFrameStyle: 'leaf',
        eyeBallStyle: 'leaf',
        fgColor: '#14713F',
        bgColor: '#F2FBF6',
        gradientEnabled: false,
    },
    {
        id: 'diamond',
        dotStyle: 'diamond',
        eyeFrameStyle: 'cut',
        eyeBallStyle: 'diamond',
        fgColor: '#3D3833',
        bgColor: '#FFF1D9',
        gradientEnabled: false,
    },
    {
        id: 'connected',
        dotStyle: 'connected',
        eyeFrameStyle: 'rounded',
        eyeBallStyle: 'circle',
        fgColor: '#0F766E',
        bgColor: '#FFFFFF',
        gradientEnabled: false,
    },
];

/**
 * Colour-only swatches: [foreground, background].
 *
 * Every pair keeps a dark code on a light field — the combination scanners read
 * most reliably — except the last, which is deliberately inverted.
 */
export const COLOR_PALETTES = [
    ['#1C1815', '#FFFFFF'],
    ['#E68A00', '#FFF8E6'],
    ['#14713F', '#F2FBF6'],
    ['#2D74D6', '#F4F8FF'],
    ['#6D5BD0', '#F7F5FF'],
    ['#D33A2C', '#FFF3EE'],
    ['#0F172A', '#F1F5F9'],
    ['#0F766E', '#ECFDF5'],
    ['#BE185D', '#FDF2F8'],
    ['#92400E', '#FFFBEB'],
    ['#1F2937', '#FEF3C7'],
    ['#FFFFFF', '#1C1815'],
];

/** The preset as a `design` patch — everything except its own id. */
export function applyStylePreset(preset) {
    const { id, ...patch } = preset;
    return patch;
}

/** True when the current design already matches every field the preset sets. */
export function isPresetActive(preset, design) {
    return Object.keys(preset)
        .filter((key) => key !== 'id')
        .every((key) => design[key] === preset[key]);
}
